import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileSourceTypeSpan',
    props: {
        type: null
    },
    setup(__props) {
        const props = __props;
        const MESSAGES = {
            posix: "This is a simple path based file source that assumes the all the relevant paths are already mounted on the Galaxy server and target worker nodes.",
            s3fs: "This is a remote file source plugin based on the Amazon Simple Storage Service (S3) interface. The AWS interface has become an industry standard and many storage vendors support it and use it to expose 'object' based storage.",
            azure: "This is a remote file source plugin based on the Azure service.",
            onedata: "This is a remote file source plugin based on the Onedata service.",
            ftp: "This is a remote file source plugin based on the FTP protocol.",
            webdav: "This is a remote file source plugin based on the WebDAV protocol.",
            dropbox: "This is a file source plugin that connects with the commercial Dropbox service.",
            googledrive: "This is a file source plugin that connects with the commercial Google Drive service.",
        };
        const title = computed(() => { var _a; return (_a = MESSAGES[props.type]) !== null && _a !== void 0 ? _a : ""; });
        return { __sfc: true, MESSAGES, props, title };
    }
});
